import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js';
import moment from 'moment';

// Register required Chart.js components
Chart.defaults.global = Chart.defaults.global || {};
Chart.defaults.global.elements = Chart.defaults.global.elements || {};
Chart.defaults.global.elements.line = Chart.defaults.global.elements.line || {};
Chart.defaults.global.elements.line.tension = 0.1;

const SubscriberChart = ({ data }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    // Clean up any existing chart
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    if (!data || data.length === 0 || !chartRef.current) {
      return;
    }

    // Sort data by date
    const sortedData = [...data].sort((a, b) => 
      moment(a.date).diff(moment(b.date))
    );

    // Extract dates and subscriber counts
    const dates = sortedData.map(item => moment(item.date).format('MMM DD'));
    const activeSubscribers = sortedData.map(item => item.active_subscribers);
    const expiredSubscribers = sortedData.map(item => item.expired_subscribers);

    // Create the chart
    const ctx = chartRef.current.getContext('2d');
    
    // Create chart configuration
    const config = {
      type: 'line',
      data: {
        labels: dates,
        datasets: [
          {
            label: 'Active Subscribers',
            data: activeSubscribers,
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            borderColor: 'rgba(54, 162, 235, 1)',
            borderWidth: 2,
            fill: true
          },
          {
            label: 'Expired Subscribers',
            data: expiredSubscribers,
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            borderColor: 'rgba(255, 99, 132, 1)',
            borderWidth: 2,
            fill: true
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'Subscriber Trends'
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: function(tooltipItem, data) {
              let label = data.datasets[tooltipItem.datasetIndex].label || '';
              if (label) {
                label += ': ';
              }
              label += tooltipItem.yLabel;
              return label;
            }
          }
        },
        legend: {
          position: 'bottom'
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: 'Number of Subscribers'
            }
          }],
          xAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Date'
            }
          }]
        }
      }
    };

    // Create the chart
    chartInstance.current = new Chart(ctx, config);

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [data]);

  return (
    <div style={{ height: '300px', position: 'relative' }}>
      {data && data.length > 0 ? (
        <canvas ref={chartRef} />
      ) : (
        <div className="text-center pt-5">No data available for the selected period</div>
      )}
    </div>
  );
};

export default SubscriberChart;